import { PcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type RejectReason = {
  requestOrganizationName: string;
  reason: string;
  svcId: string;
  partnerId: string;
}[];

export const getRejectReason = () => {
  return api<PcApiResponse<RejectReason>>('get', `/pc-api/v1/${PREFIX_PATH}/dashboard/review/reject-reason`);
};
